import { fetcher } from '@commenda/utils';

import {
  IListIndirectTaxCredentialsParams,
  IListIndirectTaxCredentialsResponse,
} from './types';

// We added listIndirectTaxCredentials for the registration form's submit
// handler—it needs to fetch credentials imperatively (fresh, sequential)
// to check/create credentials before creating a registration, which is
// cleaner than using a hook's cached data inside an async event handler.

export async function listIndirectTaxCredentials(
  params: IListIndirectTaxCredentialsParams,
  token?: string
): Promise<{
  success: boolean;
  data?: IListIndirectTaxCredentialsResponse;
  error?: string;
}> {
  try {
    const queryParams = new URLSearchParams({
      corporationId: params.corporationId.toString(),
      ...(params.portalIds && { portalIds: params.portalIds.join(',') }),
      ...(params.extendPortalDetails !== undefined && {
        extendPortalDetails: params.extendPortalDetails.toString(),
      }),
      ...(params.includeInactive !== undefined && {
        includeInactive: params.includeInactive.toString(),
      }),
    }).toString();

    const response = await fetcher(
      `new-sales-tax/credentials/list?${queryParams}`,
      { method: 'GET' },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to list credentials',
      };
    }

    const data: IListIndirectTaxCredentialsResponse = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to list credentials';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
